import {mapping} from "../../../constants/mappings";
import {favouriteType, filterDataType} from "../context/filterContext";

const contructGetFilterQuery = (filterContent: filterDataType) => {
    const baseQuery = 'SearchFilter?';
    const filters = Object.keys(filterContent);
    let query = '';
    let filterCount = 0;
    filters.map((filter)=> {
        if (filter !== 'contacts' && filter !== 'favourites' && filter !== 'search'
            && filter !== 'order' && filter !== 'users'
            && filter !== 'submissionReq' && filter !== 'categories'
            && filter !== 'companyCategories') {
            const selectedFilter =
                filterContent[filter as keyof typeof filterContent];
            if (typeof(selectedFilter) === 'object' && selectedFilter !== null) {
                selectedFilter.map((data)=> data.id).join(',');
                query += `${mapping[filter as keyof typeof mapping]}=${selectedFilter.map((data)=> data.id).join(',')}&`;
                filterCount += selectedFilter.length;
            }
        }
        return null;
    });
    filterCount += filterContent.search.length;
    query += `Search=${filterContent.search}&Order=${filterContent.order}`;
    const filterQuery = `${baseQuery}${query}`;
    return {query, baseQuery, filterQuery, filterCount};
}

const contructFavouritesQuery = (favourites: favouriteType[]) => {
    const baseQuery = 'CompanyDetail?$filter=';
    let query = '';
    favourites.forEach(({companyGroupId}, index)=> {
        query += `CompanyGroupId eq ${companyGroupId} ${index === favourites.length-1? '': 'or '}`;
    });
    const favouritesQuery = `${baseQuery}${query}`;
    return {favouritesQuery};
}

export {contructGetFilterQuery, contructFavouritesQuery};